import Vue from 'vue'

import uiProgressBar from './src/ui-progress-bar.vue';

Vue.component('ui-progress-bar', uiProgressBar);

export default uiProgressBar;



//////////////////
// WEBPACK FOOTER
// ./~/ui-progress-bar/index.js
// module id = 555
// module chunks = 0